import React, { useEffect, useState } from "react";
import { Grid, FormControlLabel, Switch, Button } from "@material-ui/core";
import { WebcamCard } from "../components/home/WebcamCard";
import { WebcamCardMediapipe } from "../components/home/WebcamCardMediapipe";

import { HomeWrapper } from "../components/utils/HomeWrapper";
import { RecordingButtons } from "../components/home/RecordingButtons";
import { VideoTimer } from "../api/VideoTimer";
import { SignDialog } from "../components/dialog/SignDialog";
// import { postmanSendVideo, postmanSendFeedback } from "../api/Postman";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import { useVideo } from "../api/VideoProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { formatAnonymous } from "../api/utils/strings";
import { CameraPermissionsPrompt } from "../components/home/CameraPermissionsPrompt";
import { pStatus, pDB_user_roles, pCustomFilter, pRecordTime } from "../utils/parameters";
import { useSnackbar } from "notistack";
//import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
//import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import CropFreeIcon from '@mui/icons-material/CropFree';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { CustomWebcamOptions } from "../components/search/CustomFilters";
// import { Visibility, VisibilityOff, BlurOn, BlurOff } from '@material-ui/icons/';
import useMediaQuery from "@mui/material/useMediaQuery";
import "../styles/devices/mob_Home.css";
import { useDataProvider } from "../api/DataProvider";
import device from "current-device";
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsSearchLSE } from "../components/tour/TourConfig";
import { useCommProvider } from "../api/CommProvider";
import { PageTitle } from '../components/utils/PageTitle';
import { useLocation } from "react-router-dom";

import { BlurOn, BlurOff } from '@material-ui/icons/';

import { WebcamSelection } from "../components/home/WebcamSelection";
import { ReminderComponent } from "../components/utils/ReminderComponent";
import { AvailableSignsTable } from "../components/search/AvailableSignsTable";

import { SubmissionBannerV2 } from "../components/search/SubmissionBanner_v2";
import { SubmissionBanner } from "../components/search/SubmissionBanner";
import { useTranslation } from "react-i18next";


var lodash = require('lodash');
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useRef } from "react";
import { DeviceQueries } from "../components/utils/DeviceQueries";


export function HomeFS() {
  const { t } = useTranslation("global")

  const [dialogElements, setDialogElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token_id, currentUser, currentUserRole, genEntryByGloss, genEntryByLemma } = useDataProvider();
  const { comm_sendVideo, comm_sendVideoFS, comm_sendMediapipe, commm_updateFeedback } = useCommProvider();
  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  const [mediapipeData, setMediapipeData] = useState(null);
  const [openOptionsMenu, setOpenOptionsMenu] = useState(false);
  const [activatedFingerSpelling, setActivatedFingerSpelling] = useState(false);
  const [optionsMenuState, setOptionsMenuState] = useState([
      false,   // offset
      true,  // showFraming
      false,  // activateKeypoints
      false,  // autoControl
      false,  // virtualBG - activate / deactivate
  ]);
  const [blurSettings, setBlurSettings] = useState({
    'blur': 0,
    'image': false
  })


  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });

  const [switchGalibo, setSwitchGalibo] = useState(true);
  const [switchSide, setSwitchSide] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const [feedback, setFeedback] = useState([]);
  const [feedback_actual_vid, setFeedback_actual_vid] = useState("");

  const [prevDialogPosition, setPrevDialogPosition] = useState(undefined);
  const [reminderSnack, setReminderSnack] = useState({ open: false, text: "" });

  const [switchMediapipe, setSwitchMediapipe] = useState(false)
  const [switchVisualControl, setSwitchVisualControl] = useState(false)
  const [enableVisualControl, setEnableVisualControl] = useState(false)
  const [visualControlAction, setVisualControlAction] = useState('')

  const [switchVirtualBG, setSwitchVirtualBG] = useState(false)
  const [virtualBGImage, setVirtualBGImage] = useState(false);
  const [virtualBGBlur, setVirtualBlur] = useState(-1);

  const [ recorderOffset, setRecorderOffset ] = useState(false)
  const [ predictionFS, setPredictionFS ] = useState(undefined);

  const [customTimerRecorder, setCustomTimerRecorder] = useState({
    'max':  pRecordTime.max,
    'min':  pRecordTime.min,
    'step':  pRecordTime.step,
    'timer': pRecordTime.default
  });

  //TEMP - USED TO BE ABLE TO OPEN PROFILE MODAL WHILE SERVER ISSUES
  /*
  const [openAccountDialog, setOpenAccountDialog] = useState(false);
  const [openWebInfoDialog, setOpenWebInfoDialog] = useState(false);
  */
 
  const queryMatches = DeviceQueries();

  /* Set initial values every time the Home page is opened */
  (() => {
    setFaceStatus(pStatus.init);
  }, [setFaceStatus]);

  async function send2Server(){
    // console.log("🚀 ~ file: Home.js:195 ~ send2Server ~ mediaBlobUrl:", mediaBlobUrl)
    if (switchMediapipe === true){
        // console.log('send2ServerMediapipe()')
        send2ServerMediapipe()
        // setSwitchMediapipe(false);
    }else{
        // console.log('send2ServerVideo()')
        send2ServerVideo()
    }
    setFaceStatus(pStatus.init)
  }

  async function send2ServerMediapipe(){

    // console.log('send2ServerMediapipe')
    setOpenDialog(true);
    setLoading(true);

    var auxSign = []
    const uid = (currentUser.isAnonymous ? formatAnonymous(currentUser.uid) : currentUser.uid)


    try{
      const videoFile = await saveVideo(mediaBlobUrl);
      auxSign = await comm_sendMediapipe(token_id, currentUser, videoFile, mediapipeData);
      // console.log('AUX SIGN: ', auxSign)
      if (auxSign['code'] === undefined){
        setFeedback_actual_vid(auxSign['_id'])
        const arr_signs = auxSign['arr_predictions']
        const arr_prob = auxSign['arr_probabilities']
        const { dialog_elements, position_gloss_uid } = genEntryByGloss(arr_signs, arr_prob);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ dialog_elements", dialog_elements);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ position_gloss_uid", position_gloss_uid);

        setDialogElements(dialog_elements);

        const initialPosition = {};
        Object.keys(position_gloss_uid).forEach((key) => {
          initialPosition[key] = position_gloss_uid[key][0];
        });
        setPrevDialogPosition(initialPosition);
        setLoading(false);
        
      }else{
        switch(auxSign['error']){
          case 'NO_MODEL':
            setSnack({ ...snack, open: true, text: "SERVIDOR PRINCIPAL CON PROBLEMAS. \n No es posible procesar los vídeos para obtener un resultado. \n Le pedimos disculpas.", type: "error" , autoHideDuration: 10000});
            break;
          case 'NO_BODY':
            setSnack({ ...snack, open: true, text: "CUERPO NO DETECTADO. \n No se ha detectado kps correspondientes al cuerpo.", type: "error" , autoHideDuration: 10000});
            break;
          case 'VIDEO_LQ':
            setSnack({ ...snack, open: true, text: "VÍDEO DE BAJA CALIDAD. \n El vídeo enviado no cumple con los requisitos de calidad mínimos.", type: "error" , autoHideDuration: 10000});
            break;
        }
        setFaceStatus(pStatus.init)
      }
    }catch(err){
      setOpenDialog(false);
      console.error(err)
      setSnack({ ...snack, open: true, text: t("sRecordComponent.serverError"), type: "error" });
    }
}


  /* Send video to server */
  async function send2ServerVideo() {
    /* 1: Dialog loading */
    setOpenDialog(true);
    setLoading(true);
    var auxSign = [];
    /* 2: Save video to file: saveVideo() */
    const videoFile = await saveVideo(mediaBlobUrl);
    // console.log("🚀 ~ file: Home.js:195 ~ send2ServerVideo ~ mediaBlobUrl:", mediaBlobUrl)
    /* 3: Get correspondent sign fro server */
    try{
      if (activatedFingerSpelling){
        auxSign = await comm_sendVideoFS(token_id, currentUser, videoFile);
        setPredictionFS({
          'inference': auxSign["fs"]["inference"],
          'total_time': auxSign["fs"]["time_info"]["total_time"],
          'video_processing_time': auxSign["fs"]["time_info"]["video_processing_time"],
          'input_adjust_time': auxSign["fs"]["time_info"]["input_adjust_time"],
          'inference_time': auxSign["fs"]["time_info"]["inference_time"]
        })
      }else{
        auxSign = await comm_sendVideo(token_id, currentUser, videoFile);
        setPredictionFS(undefined)
      }
      

      console.log('AUX SIGN: ', auxSign)

      if (auxSign['code'] === undefined){
        setFeedback_actual_vid(auxSign['_id'])
        const arr_signs = auxSign['arr_predictions']
        const arr_prob = auxSign['arr_probabilities']
        const { dialog_elements, position_gloss_uid } = genEntryByGloss(arr_signs, arr_prob, activatedFingerSpelling);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ dialog_elements", dialog_elements);
        // console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ position_gloss_uid", position_gloss_uid);

        setDialogElements(dialog_elements);

        const initialPosition = {};
        Object.keys(position_gloss_uid).forEach((key) => {
          initialPosition[key] = position_gloss_uid[key][0];
        });

        setPrevDialogPosition(initialPosition);

        setLoading(false);
        
      }else{
        switch(auxSign['error']){
          case 'NO_MODEL':
            setSnack({ ...snack, open: true, text: "SERVIDOR PRINCIPAL CON PROBLEMAS. \n No es posible procesar los vídeos para obtener un resultado. \n Le pedimos disculpas.", type: "error" , autoHideDuration: 10000});
            break;
          case 'NO_BODY':
            setSnack({ ...snack, open: true, text: "CUERPO NO DETECTADO. \n No se ha detectado kps correspondientes al cuerpo.", type: "error" , autoHideDuration: 10000});
            break;
          case 'VIDEO_LQ':
            setSnack({ ...snack, open: true, text: "VÍDEO DE BAJA CALIDAD. \n El vídeo enviado no cumple con los requisitos de calidad mínimos.", type: "error" , autoHideDuration: 10000});
            break;
        }
        setFaceStatus(pStatus.init)
      }
    }catch(err){
      setOpenDialog(false);
      console.error(err)
      setSnack({ ...snack, open: true, text: t("sRecordComponent.serverError"), type: "error" });
    }
    
  }

  /* Send video to server */
  async function sendFeedback2Server(data, data_labels) {
    try{
      commm_updateFeedback(token_id, currentUser, feedback_actual_vid, data, data_labels);
      setSnack({ ...snack, open: true, text: "Enviado su reporte. Muchas gracias por colaborar.", type: "info" });
    }catch(e){
      setSnack({ ...snack, open: true, text: e, type: "error" });
    }
  }

  /* Snackbars with info */
  useEffect(() => {
    switch (faceStatus) {
      case pStatus.runTf:
        setSnack({ ...snack, open: true, text: t("sRecordComponent.setFace"), type: "info" });
        break;
      case pStatus.record:
        setSnack({ ...snack, open: true, text: t("sRecordComponent.recording"), type: "info" });
        break;
      default:
        break;
    }
    /* eslint-disable-next-line */
  }, [faceStatus]);

  /* Check device & Camera permissions */
  useEffect(() => {
    /* Only check if there are no camera permissions */
    if (!cameraPermissions.cam) {
      /* Status and permissions prompt */
      setCameraPermissions({ ...cameraPermissions, perm: false });
      setFaceStatus(pStatus.error);
      /* Check permissions again */
      checkCameraPermissions()
        .then((r) => {
          setCameraPermissions({ ...cameraPermissions, perm: r, cam: r });
          r ? setFaceStatus(pStatus.init) : setFaceStatus(pStatus.error);
        })
        .catch((e) => setCameraPermissions({ ...cameraPermissions, perm: false, cam: false }));
    }
    // eslint-disable-next-line
  }, []);

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  /* Tour */
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  
  const { json_web_info, json_data_USER, json_data_lemma, json_data_meaning, json_data_glosses, json_data_sentence, json_data_sequence_glosses } = useDataProvider();
  const { updateServiceStatus, setToken_id, setServiceStatus, serviceStatus, comm_getUserTokenAuth } = useDataProvider();
  const { force_use_local_json } = useDataProvider();

  async function execTestCode0() {
    // console.log("🚀 ~ file: Home.js:182 ~ Home ~ token_id", token_id)
    // console.log("🚀 ~ file: Home.js:183 ~ Home ~ serviceStatus", serviceStatus)
    // console.log("🚀 ~ file: Home.js:184 ~ Home ~ json_web_info", json_web_info)
    // console.log("🚀 ~ file: Home.js:185 ~ Home ~ json_data_USER", json_data_USER)
    // console.log("🚀 ~ file: Home.js:186 ~ Home ~ json_data_glosses", json_data_glosses)
    // console.log("🚀 ~ file: Home.js:187 ~ Home ~ json_data_meaning", json_data_meaning)
    // console.log("🚀 ~ file: Home.js:188 ~ Home ~ json_data_lemma", json_data_lemma)
    // console.log("🚀 ~ file: Home.js:189 ~ Home ~ json_data_sentence", json_data_sentence)
    // console.log("🚀 ~ file: Home.js:190 ~ Home ~ json_data_sequence_glosses", json_data_sequence_glosses)
  }

  async function execTestCode1() {
    // console.log(currentUser)
    // setServiceStatus({...serviceStatus, web: false})
  }

  async function execTestCode2() {
    setServiceStatus({...serviceStatus, user: false})
  }

  async function execTestCode3() {
    setServiceStatus({...serviceStatus, data: false})
  }
    
  async function execTestCode4() {
    force_use_local_json()
  }

  async function execTestCode5() {

    setOpenDialog(true);
    setLoading(true);
    // setFeedback_actual_vid(json_data_glosses[0])

    // const arr_signs = ["w0225a", "w0202b", "w0202a"]
    // const arr_prob = [0.7, 0.2, 0.1]

    const arr_signs = [selectedElements.elemento1, selectedElements.elemento2, selectedElements.elemento3]
    const arr_prob = [selectedProbs.elemento1, selectedProbs.elemento2, selectedProbs.elemento3]

    const { dialog_elements, position_gloss_uid } = genEntryByGloss(arr_signs, arr_prob);
    console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ dialog_elements", dialog_elements);
    console.log("🚀 ~ file: SignsTable.js ~ line 267 ~ handleRowClick ~ position_gloss_uid", position_gloss_uid);

    setDialogElements(dialog_elements);

    const initialPosition = {};
    Object.keys(position_gloss_uid).forEach((key) => {
      initialPosition[key] = position_gloss_uid[key][0];
    });
    setPrevDialogPosition(initialPosition);
    setLoading(false);

  }

  const { getListAllLemmasAvailable, getListNameDefinitions } = useDataProvider();

  async function exec1() {
    console.log("exec1")
    console.log(json_data_lemma)
  }

  async function exec2() {
    console.log("exec2")
    const label = lodash.map(json_data_lemma, 'label');
    console.log(label)
  }

  async function exec3() {
    const keysWithVisibilityTrue = lodash(json_data_lemma)
      .pickBy((value) => value.visibility)
      .keys()
      .value();
    const response2 = getListNameDefinitions(keysWithVisibilityTrue);
    console.log(response2)
  }

  async function exec4() {
    const keysWithVisibilityTrue = lodash(json_data_lemma)
    .pickBy((value) => value.visibility)
    .keys()
    .value();

    const selectedData = lodash.pick(json_data_lemma, keysWithVisibilityTrue);
    const selectedDataWithDefinitions = lodash.mapValues(selectedData, (item) => {
      const definitions = lodash.map(item.arr_meanings, (meaningKey) => {
        return json_data_meaning[meaningKey].definition;
      });
      const item_lemma = lodash.omit(item, 'arr_meanings');
      return { ...item_lemma, definitions };
    });

    const dataArray = _.map(selectedDataWithDefinitions, (value, key) => {
      return { _id: key, id: lodash.indexOf(keysWithVisibilityTrue, key), ...value };
    });
    
    console.log(dataArray)
  }

  // const arr_elements = [
  //   "w0201a", "w0202a", "w0202b", "w0203a", "w0204a", "w0204b", "w0205a", "w0205b", "w0206a","w0207a", "w0207b", "w0208a", "w0209a", "w0210a", "w0211a", "w0212a", "w0212b", "w0213a",
  //   "w0214a", "w0215a", "w0216a", "w0217a", "w0218a", "w0219a", "w0220a", "w0221a", "w0222a","w0223a", "w0224a", "w0225a", "w0226a", "w0227a", "w0228a", "w0229a", "w0230a", "w0231a",
  //   "w0233a", "w0233b", "w0234a", "w0235a", "w0236a", "w0237a", "w0237b", "w0238a", "w0240a","w0241a", "w0242a", "w0243a", "w0244a", "w0245a", "w0246a", "w0247a", "w0248a", "w0248b",
  //   "w0248c", "w0249a", "w0250a", "w0251a", "w0252a", "w0253a", "w0254a", "w0255a", "w0256a","w0257a", "w0258a", "w0259a", "w0260a", "w0260b", "w0260c", "w0261a", "w0262a", "w0263a",
  //   "w0264a", "w0265a", "w0266a", "w0267a", "w0267b", "w0268a", "w0269a", "w0270a"
  // ];

  const arr_elements = Array.from({length: 301}, (_, i) => 'wm' + String(i).padStart(4, '0'));


  const [selectedElements, setSelectedElements] = useState({
    elemento1: arr_elements[0],
    elemento2: arr_elements[1],
    elemento3: arr_elements[2]
  });
  const [selectedProbs, setSelectedProbs] = useState({
    elemento1: 0.7,
    elemento2: 0.2,
    elemento3: 0.1
  });

  const handleChangeElements = (event) => {
    setSelectedElements({
      ...selectedElements,
      [event.target.name]: event.target.value,
    });
  };
  const handleChangeProb = (event) => {
    setSelectedProbs({
      ...selectedProbs,
      [event.target.name]: event.target.value,
    });
  };
  const getAvailableOptions = (currentValue, otherValues) => {
    return arr_elements.filter((element) => !otherValues.includes(element) || element === currentValue);
  };

  useEffect(() => {
    console.log("🚀 ~ file: SignsTable.js ~ line 84 ~ handleRowClick ~ json_web_info", json_web_info['server_status']);
  }, [json_web_info])

  /*** Adding AvailableSignsTable to Home ***/
  /* Show dialog */
  
  async function showDialog(row_id) {
    
    /* History */
    //addToHistory(auxSign[pDB.sign_id]).catch(e => console.error(e))
    /* No need of loading */
    const data_dialog_elements = genEntryByLemma(row_id)

    setDialogElements(genEntryByLemma(row_id));
  }

  useEffect(() => {
    if (Object.keys(dialogElements).length > 0) {
      setOpenDialog(true);
    }else{
      setOpenDialog(false);
    }
  }, [dialogElements]);


  const location = useLocation();
  useEffect(() => {
    if (location.lemma !== undefined) {
      setPrevDialogPosition({ lemma: location.lemma, meaning: location.meaning, gloss: location.gloss });
      showDialog([location.lemma])

      if (location.video_sent){
        setSnack({ ...snack, open: true, text: "Enviado su vídeo. Gracias por colaborar :)", type: "info" });
      }
      
    }
  }, [location]);

  
  function handleOptionsMenu() {
    setOpenOptionsMenu((state) => !state);
  }

  function handleFingerSpellingOption() {

    console.log(pRecordTime.max)
    console.log(pRecordTime.min)
    console.log(pRecordTime.step)
    console.log(pRecordTime.timer)
    
    if (activatedFingerSpelling){
      setActivatedFingerSpelling(false)
      setCustomTimerRecorder({
        'max':  pRecordTime.max,
        'min':  pRecordTime.min,
        'step':  pRecordTime.step,
        'timer': pRecordTime.default
      })
    }else{
      setActivatedFingerSpelling(true)
      setCustomTimerRecorder({
        'max':  15,
        'min':  5,
        'step':  1,
        'timer': 5
      })
    }

    



  }

  useEffect(() => {
    if (openOptionsMenu){
      if (switchGalibo) {
        enqueueSnackbar('Se ha activado la ayuda al encuadre.', { variant: 'success', } );
      } else{
        enqueueSnackbar('Se ha desactivado la ayuda al encuadre.', { variant: 'warning', });  
      }
    }
  }, [switchGalibo]);

  useEffect(() => {
    setEnableVisualControl(switchMediapipe)
    if (openOptionsMenu){
      if (switchMediapipe) {
        enqueueSnackbar('Se ha activado la visualización de los keypoints.', { variant: 'success', } );
      } else{
        enqueueSnackbar('Se ha desactivado la visualización de los keypoints.', { variant: 'warning', });  
      }
    }
  }, [switchMediapipe]);

  useEffect(() => {
    if (openOptionsMenu){
        if (switchVisualControl) {
          enqueueSnackbar('Se ha activado control automático.', { variant: 'success', } );
      } else{
          enqueueSnackbar('Se ha desactivado control automático.', { variant: 'warning', });  
      }
    }
  }, [switchVisualControl]);

  useEffect(() => {
    if (openOptionsMenu){
        if (switchVirtualBG) {
          enqueueSnackbar('Se ha activado virtualBG.', { variant: 'success', } );
      } else{
          enqueueSnackbar('Se ha desactivado virtualBG.', { variant: 'warning', });  
      }
    }
  }, [switchVirtualBG]);


  useEffect(() => {
    setRecorderOffset(optionsMenuState[pCustomFilter.OFFSET])
    setSwitchGalibo(optionsMenuState[pCustomFilter.FRAMING])
    setSwitchMediapipe(optionsMenuState[pCustomFilter.KPS])
    setSwitchVisualControl(optionsMenuState[pCustomFilter.CONTROL])
    setSwitchVirtualBG(optionsMenuState[pCustomFilter.VIRTUALBG])
  }, [optionsMenuState]);

  useEffect(() => {
    if(switchVirtualBG){
      console.log('change blur Setting: ', blurSettings)
    }
  }, [blurSettings]);



  // const handleWebcamOptions = (event, optionId, newOptionsState) => {
  //   switch (optionId) {
  //     case 0:
  //       toggleGalibo();
  //       break;
  //     case 1:
  //       toggleMediapipe();
  //       break;
  //     case 2:
  //       handleClick();
  //       break;
  //     case 3:
  //       toggleVirtualBG();
  //       break;
  //     default: break;
  //   }
  //   setOptionsState(newOptionsState);
  // };

  return (
    <HomeWrapper>
      <div className={`sig_ST_CustomFilters_MenuBkg ${openOptionsMenu ? "" : "sig_ST_CustomFilters_MenuBkg_Hidden"}`} onClick={handleOptionsMenu}></div>
      {json_web_info['server_status'] === 'DOWN' ? (
        <PageTitle title={t("sHub.search_in_LSE").toUpperCase()} error={t("sWebInfo.server_main_problems")}/>
      ):<></>
      }
      <Grid container className={`sig_Home_MainSectionContainer ${queryMatches.deviceLandscape ? "sig_Home_MSCLandscape" : ""}`}>
        <Grid item className={switchSide ? "sig_Home_OptionsRight" : "sig_Home_OptionsLeft"}>
          {queryMatches.desktop ? (
            <Grid container className="sig_Home_MainSectionOptions">
              <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false} permissions={cameraPermissions.cam} />    
              
              <Tooltip title={t("sFilter.cat_options")} placement='bottom-end' arrow>
                <div className="sig_Main_IconButton" style={{width: '30%'}} onClick={handleFingerSpellingOption}>
                  {activatedFingerSpelling ? <Button style={{ width: '100%', height: '100%', color: 'white', backgroundColor: "Green"}}>MODO DELETREO: ON</Button> : <Button> MODO DELETREO: OFF</Button>}
                </div>
              </Tooltip> 

              <Tooltip title={t("sFilter.cat_options")} placement='bottom-end' arrow>
                <div className="sig_Main_IconButton" onClick={handleOptionsMenu}>
                  {openOptionsMenu ? <SettingsIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" /> : <SettingsOutlinedIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip>    

              {/* <Tooltip title={t("sTooltip.help_framing")} placement="bottom-end" arrow>
                <div data-tour='tourCam_1' className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsSearchLSE, 0)}>
                  <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip> */}
            </Grid>
          ) : (
            <></>
          )}
          <Grid container className={`sig_Home_MainSectionCamera ${queryMatches.deviceLarge ? "sig_Home_MainSectionCamera_LargeDevice" : ""}`}>
            <Grid item>
              <WebcamCardMediapipe 
                devicePortrait={queryMatches.devicePortrait} 
                desktop={queryMatches.desktop}
                setMediaBlobUrl_rec={setMediaBlobUrl} 
                permissions={cameraPermissions.cam} 
                deviceId={deviceId} 
                switchGalibo={switchGalibo} 
                switchMediapipe={switchMediapipe} 
                switchVirtualBG={switchVirtualBG}
                blurSettings={blurSettings}
                setMediapipeData= {setMediapipeData} 
                handleSend={send2Server} 
                switchVisualControl={switchVisualControl} 
                setVisualControlAction={setVisualControlAction}
                offset={recorderOffset}
              >
               {/* permissions={cameraPermissions.cam} switchMediapipe={switchMediapipe} setMediapipeData= {setMediapipeData} handleSend={send2Server} switchVisualControl={switchVisualControl} setVisualControlAction={setVisualControlAction}></WebcamCardMediapipe> */}
                {!cameraPermissions.perm && <CameraPermissionsPrompt />}
              </WebcamCardMediapipe>
            </Grid>
          </Grid>
          <Grid container className={`sig_Home_MainSectionButtons ${queryMatches.deviceLarge ? "sig_Home_MainSectionButtons_LargeDevice" : ""}`}>
          {queryMatches.desktop ? (
            <>
            <Grid item className="sig_Home_ProgressContainer">
              <VideoTimer />
            </Grid>
            </>
            ) : (
            <Grid container className="sig_Home_MainSectionOptions">
              {queryMatches.deviceLandscape ? (
                <FormControlLabel
                  control={
                    <>
                      <SyncAltIcon className="sig_Home_ChangeOnDarkMode" />
                      <Switch color="primary" onClick={toggleSide} checked={switchSide} />
                    </>
                  }
                />
              ) : (
                <>
                <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false} permissions={cameraPermissions.cam} />
                </>
              )}
              <Tooltip title={t("sFilter.cat_options")} placement='bottom-end' arrow>
                <div className="sig_Main_IconButton" onClick={handleOptionsMenu}>
                  {openOptionsMenu ? <SettingsIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" /> : <SettingsOutlinedIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip>
              <Tooltip title={t("sTooltip.show_help")} placement="bottom-end" arrow>
                <div data-tour="tourCam_1" className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsSearchLSE, 0)}>
                  <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip>
            </Grid>
            )}
            <Grid item className="sig_Home_ButtonsContainerOuter">
              <RecordingButtons handleSend={send2Server} switchGalibo={switchGalibo} switchVisualControl={switchVisualControl} visualControlAction={visualControlAction} customTimer={customTimerRecorder}>
                {queryMatches.deviceLandscape ? (
                  <>
                  <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false} permissions={cameraPermissions.cam} />
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : queryMatches.devicePortrait ? (
                  <>
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : (<>
                  </>
                )}
              </RecordingButtons>
            </Grid>
          </Grid>
          <HelpSnackbar snack={snack} setSnack={setSnack} />
        </Grid>
        {/*<Grid item>
          <AvailableSignsTable showDialog={showDialog} favs={false} />
        </Grid>*/}
      </Grid>
      <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={loading} openDialog={openDialog} setOpenDialog={setOpenDialog} sendFeedback2Server={sendFeedback2Server} setFeedback={setFeedback} prevDialogPosition={prevDialogPosition} setPrevDialogPosition={setPrevDialogPosition} switchVisualControl={switchVisualControl} setVisualControlAction={setVisualControlAction} visualControlAction={visualControlAction} noCenterDialog={switchVisualControl} predictionFS={predictionFS}/>
      <CustomWebcamOptions openOptionsMenu={openOptionsMenu} setOpenOptionsMenu={setOpenOptionsMenu} optionsMenuState={optionsMenuState} setOptionsMenuState={setOptionsMenuState} blurSettings={blurSettings} setBlurSettings={setBlurSettings} userAdmin={currentUserRole === pDB_user_roles.admin}/>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
      {/* <ReminderComponent reminderSnack={reminderSnack} setReminderSnack={setReminderSnack} /> */}
      

      {/* <div style={{marginTop: '5px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '40px', width: '20%', color: 'red', backgroundColor : '#D3D3D3', border: '3px solid red'}} onClick={execTestCode0}>SHOW ALL DATA</Button>
        <Button style={{marginLeft: '20px', height: '40px', width: '20%', color: 'purple', backgroundColor : '#D3D3D3', border: '3px solid purple'}} onClick={execTestCode1}>UPDATE WEB_INFO</Button>
        <Button style={{marginLeft: '20px', height: '40px', width: '20%', color: 'blue', backgroundColor : '#D3D3D3', border: '3px solid blue'}} onClick={execTestCode2}>UPDATE USER DATA</Button>
        <Button style={{marginLeft: '20px', height: '40px', width: '20%', color: 'green', backgroundColor : '#D3D3D3', border: '3px solid green'}} onClick={execTestCode3}>UPDATE DATA LSE</Button>
      </div> */}


      {/* <div style={{marginTop: '5px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '40px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={execTestCode4}>FORCE USE LOCAL JSON !!!!</Button>
      </div>
      */}


      {/* <div style={{marginTop: '5px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '40px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={() => {setOpenAccountDialog(true);}}>OPEN PROFILE MODAL !!!!</Button>
      </div>
      <div style={{marginTop: '5px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '40px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={() => {setOpenWebInfoDialog(true);}}>OPEN SERVER MODAL !!!!</Button>
      </div>
 */}


      {/* <AccountDialog openDialog={openAccountDialog} setOpenDialog={setOpenAccountDialog}/>
      <WebInfoDialog openDialog={openWebInfoDialog} setOpenDialog={setOpenWebInfoDialog}/> */}
     
      {/* <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '50px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={exec1}> EXEC1 </Button>
      </div>
      <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '50px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={exec2}> EXEC2 </Button>
      </div>
      <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '50px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={exec3}> EXEC3 </Button>
      </div>
      <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '50px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={exec4}> EXEC4 </Button>
      </div> */}


      {/* <div style={{marginTop: '5px', display: 'flex', justifyContent: 'center', background: 'gray'}}>
        <Button style={{height: '40px', width: '80%', color: 'black', backgroundColor : '#D3D3D3', border: '3px solid black'}} onClick={execTestCode5}>GENERATE RCV PREDICTIONS !!!!</Button>
      </div>  */}



      {/* <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', background: 'white'}}>
        <FormControl style={{paddingRight: '20px'}}>
          <Select name="elemento1" size="small" value={selectedElements.elemento1} onChange={handleChangeElements} >
            {getAvailableOptions(selectedElements.elemento1, [selectedElements.elemento2, selectedElements.elemento3]).map((element) => (
              <MenuItem key={element} value={element}> {element} </MenuItem>
            ))}
          </Select>
          <TextField name="elemento1" size="small" value={selectedProbs.elemento1} onChange={handleChangeProb} />
        </FormControl>
        <FormControl style={{paddingRight: '20px'}}>
          <Select name="elemento2" size="small" value={selectedElements.elemento2} onChange={handleChangeElements} >
            {getAvailableOptions(selectedElements.elemento2, [selectedElements.elemento1, selectedElements.elemento3]).map((element) => (
              <MenuItem key={element} value={element}> {element} </MenuItem>
            ))}
          </Select>
          <TextField name="elemento2" size="small" value={selectedProbs.elemento2} onChange={handleChangeProb} />
        </FormControl>
        <FormControl style={{paddingRight: '20px'}}>
          <Select name="elemento3" size="small" value={selectedElements.elemento3} onChange={handleChangeElements} >
            {getAvailableOptions(selectedElements.elemento3, [selectedElements.elemento1, selectedElements.elemento2]).map((element) => (
              <MenuItem key={element} value={element}> {element} </MenuItem>
            ))}
          </Select>
          <TextField name="elemento3" size="small" value={selectedProbs.elemento3} onChange={handleChangeProb} />
        </FormControl>
      </div> */}



    </HomeWrapper>
  );

}


